export default class Roles
{
    public static ROLE_NOTIFICATION_SEND: string = "NotificationSend";
    public static ROLE_PROMOCODES_MANAGING: string = "PromocodesManaging";
    public static ROLE_HOMEFEED_MANAGING: string = "HomefeedManaging";
}